import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_IN_LAN_DONG_LAI } from "actions/InLanDongLai/actionTypes";
import {
  getInLanDongLaiSuccess,
  getInLanDongLaiFailure,
} from "actions/InLanDongLai";
import { pushNotification } from "utils/notifications";
import InLanDongLaiApi from "service/inLanDongLaiApi";

function* getInLanDongLai(action) {
  try {
    const response = yield call(
      InLanDongLaiApi.getInLanDongLai,
      action.dataSearch
    );
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(getInLanDongLaiFailure());
      } else {
        yield put(getInLanDongLaiSuccess(response.data));
      }
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getInLanDongLaiFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getInLanDongLaiFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_IN_LAN_DONG_LAI, getInLanDongLai);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
